import * as React from 'react'
import { Link} from 'react-router-dom'
import { Grid, Typography, Box, Button} from '@mui/material'
import axios from 'axios'
import DashboardIcon from '@mui/icons-material/Dashboard'
import { ErrorAlert } from '../../../alerts/ErrorAlert'
import { axiosErrorHandling } from '../../../misc/other'



export const AdminCompleted = ()=>{
    

    const [error, setError] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState('')

    const closeError = () =>{
        setError(false)
    }

    React.useEffect(()=>{
    const context = JSON.parse(window.localStorage.getItem('usercontext'))
    
    const activeAccounts = context.active_accounts - context.accounts_settled
    axios({method: 'POST',
           url: 'api/oracle3/activeaccounts',
           data: {customer_number: context.customer_number, active_accounts:activeAccounts}     
    }).catch(err=>{
        let errMessage = axiosErrorHandling(err)
        setErrorMessage(errMessage)
        setError(true)
        
    })

},[])



        const path =  '../dashboard'   
        
        return(
           
            <Box sx={{minHeight:'80vh', mt: 15, mb: 2}}>
               <ErrorAlert error={errorMessage} open={error} handleClose={closeError}/>
            <Grid container direction='row' sx={{justifyContent:'center', alignItems:'center'}} >
            <Grid size={{xs: 7, sm: 6, lg: 4}}>
            <Typography variant='h6'gutterBottom={true}>Payment Has Been Processed...Tell the customer to check their inbox for the settlement letter. The downloaded one can also be re-sent.  Make sure the customer keeps the letter on file for future reference. Remind the customer that if any other entity requests to settle the debt please show them this letter. Also, let the customer know,  NameMySettlement.com will be sending a receipt by the end of the next business day. </Typography>
            </Grid>
            </Grid>
            <Grid container direction='row' sx={{justifyContent:'center', alignItems:'center'}}>
            <Grid>
            <Button endIcon={<DashboardIcon />} component={Link} to={path}  variant='contained' color='primary'> Go Back To Account Home </Button>
            
            </Grid>
            </Grid>
            
            </Box>
            
            
        )
    
    }